import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const RateCellEditor = forwardRef((props: any, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [value, setValue] = useState(props.value?.toString() || "");

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;

    const pattern = new RegExp(/^[0123456789.%]+$/);

    //after % don't allow any more characters
    if (pattern.test(input.split("%")[1])) {
      return;
    }

    //allow .  only once
    const patternToCheckForDecimal = /\..*\./;
    if (patternToCheckForDecimal.test(input)) {
      return;
    }

    if (pattern.test(input.split(".")[1])) {
      //limit to 14 dp unless adding a %
      const decimalvalue = input.split(".")[1];
      if (decimalvalue.length > 14 && !input.includes("%")) {
        return;
      }
    }

    if (pattern.test(input) || input == "") {
      setValue(input);
    }
  };

  const validateAndSave = () => {
    //convert value to be 16dp including trailing 0's
    if (value == "") {
      return null;
    }

    // if (value.includes("%")) {
    //   const number = Number(value.split("%")[0]);
    //   const numToSave = ((number * 1000) / 100).toFixed(16);
    //   // const numToSave = Math.d

    //   // if (value.split(".")[1].length > 15) {
    //   //   numToSave = (number / 100).toFixed(16);
    //   // } else {
    //   //   // numToSave = number / 100;
    //   //   numToSave = (number / 100).toFixed(16);
    //   // }

    //   return Number(numToSave);
    // }

    return Number(value);
  };

  useImperativeHandle(ref, () => ({
    getValue: () => validateAndSave(),
  }));

  return (
    <input
      ref={inputRef}
      type="string"
      value={value}
      onChange={handleInput}
      className={`ag-input ag-roundedInputStyle flex w-full justify-center text-center`}
    />
  );
});

export default RateCellEditor;
